import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { AccordionCollapsible } from 'components/UI/Accordion/AccordionCollapsible';
import Image from 'components/UI/Image/Image';
import { asPerformanceDate } from 'utils/date-formatter';
import parse from 'html-react-parser';

export const UpsellEventInformation = (props) => {
  const {
    Title,
    Imagepath,
    Performance: { Description, DateTime, Venue },
    UpsellType,
    SitecoreDescription,
    ItemCount,
    CollectionInfoTitle,
    CollectionInfoDescription,
  } = props;
  const [moreInfoPanelIsActive, setMoreInfoPanelIsActive] = useState(false);
  const infoOpenClass = moreInfoPanelIsActive ? 'info-button--open' : '';
  const infoButtonClasses = ['btn-link bold info-button', infoOpenClass].join(' ');

  const moreInfoButtonClickHandler = (event) => {
    setMoreInfoPanelIsActive((prevState) => !prevState);
    event.preventDefault();
  };

  return (
    <div className="panel-body panel-has-img" data-testid="upsells-event-info">
      <h3 className="title">{Title}</h3>

      <Image
        alt={Description}
        desktopImage={Imagepath}
        extendClass="img-framed img-responsive"
        extendTestId="upsells-thumb"
      />

      {(UpsellType === 'Performance' || UpsellType === 'Lunchbox') && (
        <h4 className="subtitle" data-testid="event-venue">
          Venue: {Venue}
        </h4>
      )}

      <p data-testid="event-date">{asPerformanceDate(DateTime)}</p>
      <p data-testid="event-desc">{parse(SitecoreDescription)}</p>
      <p>
        <a
          href="#"
          className={infoButtonClasses}
          role="button"
          onClick={moreInfoButtonClickHandler}
        >
          {CollectionInfoTitle}
          <span className="caret" />
        </a>
      </p>

      <AccordionCollapsible id={`moreinfo${ItemCount}`} isActive={moreInfoPanelIsActive}>
        <p>{parse(CollectionInfoDescription)}</p>
      </AccordionCollapsible>
    </div>
  );
};

UpsellEventInformation.propTypes = {
  Title: PropTypes.string,
  Imagepath: PropTypes.string,
  Performance: PropTypes.object,
  UpsellType: PropTypes.string,
  SitecoreDescription: PropTypes.string,
  ItemCount: PropTypes.string,
  CollectionInfoTitle: PropTypes.string,
  CollectionInfoDescription: PropTypes.string,
};
